import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import { DigitalMeter } from "../classes/DigitalMeter.class";
export class ExportDigitalMeterReport {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportDigitalMeterReport(meters, startDate, endDate) {
    const digitalMeters = meters.filter(d => d.digitalMeterData); 
    const hashCustIdGroups = {};
    for (let meter of digitalMeters) {
      let digitalMeterData = meter.digitalMeterData;
      let key = digitalMeterData.partner + "_" + digitalMeterData.type + "_" + digitalMeterData.cust_id;
      if (!hashCustIdGroups[key]) {
        hashCustIdGroups[key] = {
          partner: digitalMeterData.partner,
          type: digitalMeterData.type,
          cust_id: digitalMeterData.cust_id
        };
      }
    }
    
    const allSets = [];
    const apiPromises = [];

    let convertStartDate = moment(startDate).format("YYYY-M-D");
    let convertEndDate = moment(endDate).add(1, 'day').format("YYYY-M-D");

    for (let key in hashCustIdGroups) {
      const group = hashCustIdGroups[key];
      const promise = DigitalMeter.getLatestDigitalMeterData(
        group.partner,
        group.type,
        group.cust_id,
        convertStartDate,
        convertEndDate
      )
      apiPromises.push(promise);
    }

    const results = await Promise.all(apiPromises);
    results.forEach(result => {
      if (result.length > 0) {
        allSets.push(...result);
      }
    });

    // สร้าง Excel file
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");

    let filteredSets = [];

    if (allSets.length > 0) {
      const latestByDate = new Map();

      allSets.forEach(set => {
        const dateKey = moment(set.datetime).format("YYYY-MM-DD");
        const key = `${dateKey}_${set.cust_id}`;
        const currentSet = latestByDate.get(key);

        if (!currentSet || moment(set.datetime).isAfter(moment(currentSet.datetime))) {
          latestByDate.set(key, set);
        }
      });
      filteredSets = Array.from(latestByDate.values()).sort((a, b) => moment(a.datetime).diff(moment(b.datetime)));
    } else {
      const start = moment(startDate);
      const end = moment(endDate);
      
      for (let date = start.clone(); date.isSameOrBefore(end); date.add(1, 'day')) {
        filteredSets.push({
          datetime: date.format("YYYY-MM-DD"),
          cust_id: null,
          data: {}
        });
      }
    }
    
    const startOfMonth = moment(startDate).startOf('month');
    const endOfMonth = moment(endDate).endOf('month');
    
    const columns = [
      {
        header: 'No.',
        key: 'name',
        width: 30,
        style: {
          alignment: {
            horizontal: 'left',
            vertical: 'middle'
          }
        }
      }
    ];

    for (let date = startOfMonth.clone(); date.isSameOrBefore(endOfMonth); date.add(1, 'day')) {
      const dateHeader = new Date(moment(date).format("YYYY-MM-DD"));
      const dateKey = moment(date).format("YYYY-MM-DD");
      columns.push({
        header: dateHeader,
        key: `datetime_${dateKey}`,
        width: 20,
        style: {
          alignment: {
            horizontal: 'right',
            vertical: 'middle'
          }
        }
      });
    }

    worksheet.columns = columns

    const dataByDateAndCustId = new Map();
    filteredSets.forEach(set => {
      const dateKey = moment(set.datetime).format("YYYY-MM-DD");
      const key = `${dateKey}_${set.cust_id}`;
      dataByDateAndCustId.set(key, set);
    });

    for (let meter of digitalMeters) {
      let areaName = meter.area.name
      let meterName = meter.isMain ? "" : meter.name
      let digitalMeterData = meter.digitalMeterData
      const rowData = { name: areaName + " " + meterName }

      for (let date = startOfMonth.clone(); date.isSameOrBefore(endOfMonth); date.add(1, 'day')) {
        const dateKey = `datetime_${date.format("YYYY-MM-DD")}`;
        const lookupKey = `${date.format("YYYY-MM-DD")}_${digitalMeterData.cust_id}`;
        
        const set = dataByDateAndCustId.get(lookupKey);
        
        if (!set) {
          rowData[dateKey] = "-";
          continue;
        }

        const meterId = set.data && set.data[digitalMeterData.meter_id];
        if (!meterId) {
          rowData[dateKey] = "-";
        } else {
          rowData[dateKey] = meterId.energy || meterId.energy == 0 ? meterId.energy : "-";
        }
      }
      
      worksheet.addRow(rowData);
    }

    const fileName = `digital-meter-report-${moment(startDate).format("YYYY-MM-DD")}-to-${moment(endDate).format("YYYY-MM-DD")}`;
    return this.saveFile(workbook, fileName);
  }
}